import {FormSectionType, FormTextType} from '../../../../../../blocks/FormBlock'

import box from '../../fields/box'
import city from '../../fields/city'
import companyName from '../../fields/copmanyName'
import confirmEMail from '../../fields/confirmEMail'
import email from '../../fields/eMail'
import houseNumber from '../../fields/houseNumber'
import street from '../../fields/street'
import zip from '../../fields/zip'
import {copy} from '../../../../../../../util/fieldscopy'

const companyHelpText: FormTextType = {
	id: 0,
	parent_id: 2,
	channel: 'text',
	name: 'companyHelpText',
	text:
		copy?.company_help ||
		'<p>Naam is enkel van toepassing bij bedrijf of organisatie.</p>'
}

const invoiceData: FormSectionType = {
	id: 2,
	parent_id: 2,
	channel: 'section',
	label: copy?.invoice_details || 'Facturatiegegevens',
	fields: [
		companyName,
		companyHelpText,
		{...email, label: copy?.invoice || 'Facturatie e-mailadres'},
		{
			...confirmEMail,
			label: copy?.confirm_invoice || 'Herhaal facturatie e-mailadres'
		},
		street,
		houseNumber,
		box,
		zip,
		city
	].map((field) => {
		return {...field, parent_id: 2}
	})
}

export default invoiceData
